import { forwardRef } from "react";
import clsx from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

/**
 * @typedef {React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
 *   textAreaClassName?: string;
 * }} CommonTextAreaProps
 */

/** @type {React.ForwardRefExoticComponent<CommonTextAreaProps & React.RefAttributes<HTMLTextAreaElement>>} */
const CommonTextArea = forwardRef(
  (
    {
      defaultValue = "",
      value,
      placeholder = "Enter text here...",
      onChange,
      onKeyDown,
      className = "",
      textAreaClassName = "",
      rows = 4,
      disabled = false,
      ...props
    },
    ref,
  ) => {
    const valueProps = value === undefined ? { defaultValue } : { value };

    return (
      <div
        className={cn(
          "w-full min-w-[212px] rounded-lg transition-colors",
          disabled
            ? "border border-gray-200 dark:border-gray-800 bg-gray-100 dark:bg-gray-800/50 cursor-not-allowed opacity-70"
            : "border border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm focus-within:border-secondary focus-within:border-[1.5px]",
          className,
        )}
      >
        <textarea
          ref={ref}
          className={cn(
            "w-full text-[12.5px] font-normal text-gray-800 dark:text-gray-100 rounded-lg px-3 py-2 resize-none bg-transparent outline-none ring-0 border-0 focus:outline-none focus:ring-0 placeholder:text-gray-500 dark:placeholder:text-gray-400 disabled:cursor-not-allowed disabled:text-gray-400 dark:disabled:text-gray-500",
            textAreaClassName,
          )}
          {...valueProps}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown}
          rows={rows}
          disabled={disabled}
          {...props}
        />
      </div>
    );
  },
);

export default CommonTextArea;
